function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getInvoiceRecordDetail, changeInvoiceStatus } from '@/api/invoiceRecord';
import uploadFile from '@/components/Upload/uploadFile';
export default {
  name: 'InvoiceUploadForm',
  components: {
    uploadFile: uploadFile
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialogTitle: '开票上传',
      loading: false,
      uploadedFileUrl: '',
      remark: '',
      invoiceInfo: {}
    };
  },
  methods: {
    /** 打开弹窗 */open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(invoiceId) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.dialogVisible = true;
              this.loading = true;
              this.uploadedFileUrl = '';
              this.remark = '';
              _context.p = 1;
              _context.n = 2;
              return getInvoiceRecordDetail(invoiceId);
            case 2:
              this.invoiceInfo = _context.v;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取发票信息失败:', _t);
              this.$message.error('获取发票信息失败');
              this.dialogVisible = false;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    /** 确认开票（状态=已开票） */confirmInvoice: function () {
      var _confirmInvoice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.uploadedFileUrl) {
                _context2.n = 1;
                break;
              }
              this.$message.error('请上传开票附件');
              return _context2.a(2);
            case 1:
              this.loading = true;
              _context2.p = 2;
              _context2.n = 3;
              return changeInvoiceStatus({
                id: this.invoiceInfo.id,
                status: 1,
                attachmentUrl: this.uploadedFileUrl,
                remark: this.remark || ''
              });
            case 3:
              this.$message.success('已确认开票');
              this.dialogVisible = false;
              this.$emit('success');
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('开票失败:', _t2);
              this.$message.error('开票失败，请重试');
            case 5:
              _context2.p = 5;
              this.loading = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function confirmInvoice() {
        return _confirmInvoice.apply(this, arguments);
      }
      return confirmInvoice;
    }(),
    /** 拒绝开票（状态=已拒绝） */rejectInvoice: function () {
      var _rejectInvoice = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              _context3.p = 1;
              _context3.n = 2;
              return changeInvoiceStatus({
                id: this.invoiceInfo.id,
                status: 2,
                attachmentUrl: this.uploadedFileUrl || '',
                remark: this.remark || ''
              });
            case 2:
              this.$message.success('已拒绝开票');
              this.dialogVisible = false;
              this.$emit('success');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('拒绝开票失败:', _t3);
              this.$message.error('拒绝开票失败，请重试');
            case 4:
              _context3.p = 4;
              this.loading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function rejectInvoice() {
        return _rejectInvoice.apply(this, arguments);
      }
      return rejectInvoice;
    }()
  }
};